module.exports = __webpack_public_path__ + "static/media/fileXsl.84e74a05.PNG";